import React from 'react';
import { Box, Typography, List, ListItem, ListItemButton, ListItemText } from '@mui/material';

function OpenRegistrationsList({ openRegistrations, handleEndTime }) {
  return (
    <Box sx={{ mt: 4, mb: 2, width: '100%' }}>
      <Typography variant="h6">Åbne Tidsregistreringer</Typography>
      <List>
        {openRegistrations.map((registration) => (
          <ListItem key={registration.id} disableGutters>
            <ListItemButton onClick={() => handleEndTime(registration)}>
              <ListItemText
                primary={`Dato: ${registration.date}, Starttid: ${registration.start_time}`}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}

export default OpenRegistrationsList;
